import MapperBase from '../MapperBase.js';
import PitchCall from '../../enums/PitchCall.js';

class MlbPitchCallMapper extends MapperBase {
    constructor(silent) {
        super(silent, PitchCall.Unidentified.key);
    }

    mapSingle(item) {
        // Unfortunately there is no api doc containing all possible values for this...
        // found some values using JSON Path liveData.plays.allPlays[*].playEvents[*].details.call.code
        // @see also https://fastballs.wordpress.com/category/pitchfx-glossary/
        // finally @see https://www.kaggle.com/pschale/mlb-pitch-data-20152018
        switch (item) {
            case 'B': // Ball
            case '*B': // Ball In Dirt
                return PitchCall.Ball.key;
            case 'C': // Called Strike
                return PitchCall.CalledStrike.key;
            case 'S': // Swinging Strike
            case 'W': // Swinging Strike (Blocked)
            case 'Q': // Swinging pitchout
            case 'M': // Missed Bunt
                return PitchCall.SwingingStrike.key;
            case 'X': // In play, out(s)
            case 'D': // In play, no out
            case 'E': // In play, run(s)
                return PitchCall.BallInPlay.key;
            case 'F': // Foul
            case 'R': // Foul pitchout
                return PitchCall.FoulBall.key;
            case 'L': // Foul Bunt
                return PitchCall.FoulBunt.key;
            case 'H': // Hit By Pitch
                return PitchCall.HitByPitch.key;
            case 'V': // Automatic Ball
                return PitchCall.IllegalPitch.key; // TODO - check it
            case 'I': // Intent Walk
                return PitchCall.IntentionalBall.key;
            case 'T': // Foul Tip
                return PitchCall.FoulTip.key;
            case 'P': // Pitchout
                return PitchCall.PitchOut.key;
            case 'P': // Pitchout
                return PitchCall.SwingingStrike.key;
        }

        throw new Error(`Unable to map pitch call code ${item}`);
    }
}

export default MlbPitchCallMapper;